export const DEFAULT_PHASER_DIMENSIONS = {
  width: 360,
  height: 640,
};

export const DEFAULT_PHASER_BACKGROUND = '#101826';

export function createSharedPhaserConfig(overrides = {}) {
  return {
    width: DEFAULT_PHASER_DIMENSIONS.width,
    height: DEFAULT_PHASER_DIMENSIONS.height,
    backgroundColor: DEFAULT_PHASER_BACKGROUND,
    ...overrides,
  };
}
